export const BSAE_URL = process.env.NODE_ENV === 'production' ? 'https://cw.beizengkj.com/api' : '/api'